module.exports = __webpack_public_path__ + "static/media/late-payment-interest.9d5b2229.svg";